<template>
    <div class="box">
        <div class="boxCard">
            <div class="boxCardTitle">超期预警</div>
        </div>
        <div class="boxCard">
           <vc-calendar borderless />
        </div>
        <div class="boxCard">
            3
        </div>
        <div class="boxCard">
            <div class="boxCardTitle">时间线</div>
            <div class="boxCardContent">
                <el-timeline >
                    <el-timeline-item
                    v-for="item in activities"
                    :key="item.id"
                    :timestamp="item.releaseDate">
                    {{item.title}}
                    </el-timeline-item>
                </el-timeline>
            </div>
        </div>
      
    </div>
</template>
<script>

export default {
    //组件创建
    created() {
    },
    mounted() {
        this.getHistoryList();
    },
    data() {
        return {
            calendarValue: new Date(),
            activities:[], // 时间线数据
        }
    },
    methods: {
        getHistoryList(){
            this.$api.getHistoryList().then(res => {
                this.activities = res
            })
        }
    }   
}
</script>
<style lang="less" scoped>
.box{
    width: 100%;
    height: calc(100vh - 88px);
    display: grid;
    grid-template-columns: 69fr 29fr;
    grid-template-rows: 50fr  50fr;
    gap: 20px;
    box-sizing: border-box;
    padding: 5px 20px; /* 左右统一边框宽度 */
}
.boxCard{
    // width: 100%;
    // height: 100%;
    overflow: hidden;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    border-radius: 8px;
    border: 1px solid #ebeef5;
    background-color: #fff;
    color: #303133;
    transition: .3s;
    padding: 10px;
    display: flex;
    flex-direction: column;
}
.boxCardTitle{
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
}
.boxCardContent{
    width: 100%;
    flex: 1;
    overflow-y: auto;

}
</style>